// This module simply logs every action to console to simplify debugging
/* tslint:disable:no-console */

import { AnyAction, Middleware, Dispatch } from "redux";
import { IStoreState } from "../rootReducer";

export const loggerMiddleware: Middleware<Dispatch<AnyAction>, IStoreState> =
  (storeAPI) => (next) => (action: AnyAction) => {
    console.log(
      `%c ${action.type}`,
      "font-weight: bold",
      action.type !== "AUTH_TOKEN_UPDATE_FULFILLED"
        ? action.payload
        : "<hidden>",
    );
    return next(action);
  };
